<template>
  <li class="nav-item dropdown no-caret" v-if="!!currentUser">
    <!-- Show current tab, plus current user info -->
    <!-- Click to drop down list of other tabs, or log out -->
    <a ref="dropdownToggle"
       class="dropdown-toggle btn rounded-circle btn-primary d-flex flex-row align-items-center justify-content-center"
       style="width:36px;height:36px;line-height:36px;padding:0"
       href="#"
       data-bs-toggle="dropdown">
      <span class="text-uppercase text-white">{{ currentUser.initials }}</span>
    </a>
    <ul class="dropdown-menu dropdown-menu-end overflow-auto" :style="`max-height:${maxMenuHeight}px`">
      <li>
        <h6 class="dropdown-header pb-0">
          {{ currentUser.displayName || 'Logged in as' }}
        </h6>
        <h6 class="dropdown-header">{{ currentUser.email }}</h6>
      </li>
      <li><hr class="dropdown-divider"/></li>
      <template v-if="currentUser.role === 'admin'">
        <li>
          <router-link :to="{name:'home'}" class="dropdown-item">
            Home
          </router-link>
        </li>
        <li v-if="$route.params.cityId">
          <router-link :to="{name:'admin-city',params:{cityId:$route.params.cityId}}" class="dropdown-item">
            Admin Console
          </router-link>
        </li>
        <li v-else>
          <router-link :to="{name:'admin'}" class="dropdown-item">
            Admin Console
          </router-link>
        </li>
        <li><hr class="dropdown-divider"/></li>
      </template>
      <template v-if="Boolean(currentUser)">
        <li>
          <a class="dropdown-item" href="#" @click.prevent="showChangeDisplayNameModal = true" disabled>Change Display Name</a>
        </li>
        <li>
          <a class="dropdown-item" href="#" @click.prevent="showChangePasswordModal = true">Change Password</a>
        </li>
        <li><hr class="dropdown-divider"/></li>
      </template>
      <template v-if="showChangelog">
        <li>
          <router-link :to="{name:'whats-new'}" class="dropdown-item">
            What's new
          </router-link>
        </li>
        <li><hr class="dropdown-divider"/></li>
      </template>
      <li><a class="dropdown-item" href="#" @click.prevent="() => logout()">Logout</a></li>
    </ul>
  </li>
  <ChangeOwnPasswordModal v-model="showChangePasswordModal" />
  <ChangeDisplayNameModal v-model="showChangeDisplayNameModal" />
</template>

<script>
import {Session} from "@/models/User";
import {canViewChangelog} from '@/changelog';
import ChangeOwnPasswordModal from "@/components/modals/ChangeOwnPasswordModal.vue";
import ChangeDisplayNameModal from "@/components/modals/ChangeDisplayNameModal.vue";
export default {
  components: {ChangeDisplayNameModal, ChangeOwnPasswordModal},
  data() {
    return {
      showChangePasswordModal: false,
      showChangeDisplayNameModal: false
    };
  },
  computed: {
    currentUser() {
      return Session.currentUser.value;
    },
    showChangelog() {
      return Session.currentUserChecked.value && canViewChangelog(this.currentUser);
    },
    maxMenuHeight() {
      return document.getElementById('app').clientHeight - 70;
    }
  },
  methods: {
    logout() {
      Session.logout()
      .then(() => {
        this.$router.push({name:'home'});
      });
    }
  }
}
</script>
